// @flow

import { backendAxios } from './axios-config';
import isEmpty from 'lodash/isEmpty';
import CustomError from '../utils/error';

const { REACT_APP_WB_BACKEND_URL } = process.env;

const getPolicyDocumentsNotices = (policyId: string, username: string) => {
  if (isEmpty(REACT_APP_WB_BACKEND_URL)) throw new CustomError('Empty URL');

  const params = { username };

  return backendAxios.get(`/policies/${policyId}/documents/enotices`, {
    params,
  });
};

export default getPolicyDocumentsNotices;
